import { render } from "./IconRightArrow.vue?vue&type=template&id=f9b9c412&ts=true"
import script from "./IconRightArrow.vue?vue&type=script&lang=ts"
export * from "./IconRightArrow.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__